import React, {
  FC, useState,
} from 'react';
import { IoIosCloseCircleOutline } from "react-icons/io";
import {
  ColumnCenter,
} from '../../Styles';
import { getWindowWidth, isMobile } from '../../../../../../../lib/utils/utils';
import RowCenter from '../../../../../../../components/Layout/RowCenter';
import InterMediumText from '../../../../../../../components/Text/InterMediumText';
import InterBoldText from '../../../../../../../components/Text/InterBoldText';
import PingFangMediumText from '../../../../../../../components/Text/PingFangMediumText';
import Input from '../../../../../../../components/Input';
import { HungryPanda } from '../../../../../../../assets/base64Images/square-platform/platform-1';
import { UberEats } from '../../../../../../../assets/base64Images/square-platform/platform-3';
import { Fantuan } from '../../../../../../../assets/base64Images/square-platform/platform-2';
import { Menulog } from '../../../../../../../assets/base64Images/square-platform/platform-4';
import { Doordash } from '../../../../../../../assets/base64Images/square-platform/platform-5';
import { Toll } from '../../../../../../../assets/base64Images/square-platform/toll';
import { Amazon } from '../../../../../../../assets/base64Images/square-platform/amazon';
import { DHL } from '../../../../../../../assets/base64Images/square-platform/dhl';
import { FedEx } from '../../../../../../../assets/base64Images/square-platform/fedEx';
import { AusPost } from '../../../../../../../assets/base64Images/square-platform/ausPost';
import Button from '../../../../../../../components/Button';

const UserName: FC<Props> = ({
  isEnglish,
  formError,
  fullName,
  setFullName,
  userNameList,
  setUserNameList,
  expressNameList,
  setExpressNameList,
}) => {
  const inputWidth = isMobile() ? getWindowWidth() - 40 : 400;
  const logoSize = inputWidth / 5 * 0.65;

  return (
    <div style={{ marginTop: 30 }}>
      {/* 全名 */}
      <div style={{ width: isMobile() ? getWindowWidth() - 40 : 400, marginTop: '25px', marginLeft: 'auto', marginRight: 'auto', textAlign: 'center' }}>
        {
          isEnglish ? (
            <InterMediumText fontSize={16} lineHeight={22}>
              Your full name<InterBoldText color={'#F44336'} fontSize={20} isSpan={true}>*</InterBoldText>
            </InterMediumText>
          ) : (
            <PingFangMediumText fontSize={16} color={'#000000'}>
              你的全名<InterBoldText color={'#F44336'} fontSize={20} isSpan={true}>*</InterBoldText>
            </PingFangMediumText>
          )
        }
      </div>

      {/* 名字输入框 */}
      <ColumnCenter style={{ height: 60, width: inputWidth, marginLeft: 'auto', marginRight: 'auto', alignItems: 'center', backgroundColor: 'rgba(228, 228, 228, 0.5)', borderRadius: 5, marginTop: 10 }}>
        {
          <Input
            style={{
              border: 'none',
              outline: 'none',
              fontSize: '18px',
              fontFamily: 'Inter-Regular, Inter',
              fontWeight: 400,
              color: '#000000',
              backgroundColor: 'transparent',
              lineHeight: '35px',
              width: inputWidth - 20,
              textAlign: 'center',
            }}
            autoFocus={true}
            placeholder={isEnglish ? 'Your full name' : '你的全名'}
            placeFontFamily={'Inter-Regular, Inter'}
            placeholderColor={'rgba(0, 0, 0, 0.5)'}
            value={fullName}
            onChange={(e) => {
              setFullName(e.target.value);
            }}
          />
        }
      </ColumnCenter>

      {/* 领取外卖/快递的姓名 */}
      <div style={{ width: inputWidth, marginLeft: 'auto', marginRight: 'auto' }}>
        <div style={{ width: 250, marginTop: '25px', marginLeft: 'auto', marginRight: 'auto' }}>
          {
            isEnglish ? (
              <InterMediumText fontSize={16} lineHeight={22} textAlign={'center'}>
                Your name(s) used on different delivery platforms
              </InterMediumText>
            ) : (
              <PingFangMediumText fontSize={16} color={'#000000'} textAlign={'center'}>
                你在不同配送平台上使用的名字
              </PingFangMediumText>
            )
          }
        </div>
      </div>

      {/* 领取外卖的姓名 */}
      <div style={{ backgroundColor: 'rgba(228, 228, 228, 0.5)', borderRadius: 5, width: inputWidth, marginLeft: 'auto', marginRight: 'auto', marginTop: 5 }}>
        <RowCenter style={{ paddingTop: 10, marginBottom: 20 }}>
          <img src={UberEats} style={{ height: logoSize, width: logoSize }} />
          <img src={HungryPanda} style={{ height: logoSize, width: logoSize, marginLeft: 10 }} />
          <img src={Fantuan} style={{ height: logoSize, width: logoSize, marginLeft: 10 }} />
          <img src={Menulog} style={{ height: logoSize, width: logoSize, marginLeft: 10 }} />
          <img src={Doordash} style={{ height: logoSize, width: logoSize, marginLeft: 10 }} />
        </RowCenter>
        {
          userNameList.map((name, index) => (
            <React.Fragment key={index}>
              {
                index === 0 && !name && (
                  <InterBoldText position={'absolute'} color={'#F44336'} fontSize={20} isSpan={true} marginTop={8} marginLeft={inputWidth - (isEnglish ? 55 : 85)}>*</InterBoldText>
                )
              }
              {
                name && (
                  <Button
                    style={{ position: 'absolute', marginLeft: inputWidth - 29, marginTop: 10 }}
                    onClick={() => {
                      const newList = [...userNameList];
                      newList[index] = '';
                      setUserNameList(newList);
                    }}
                  >
                    <IoIosCloseCircleOutline style={{ fontSize: 23, color: '#000000' }} />
                  </Button>
                )
              }
              <Input
                style={{
                  border: 'none',
                  outline: 'none',
                  fontSize: '18px',
                  fontFamily: 'Inter-Regular, Inter',
                  fontWeight: 400,
                  color: '#000000',
                  backgroundColor: 'transparent',
                  lineHeight: '35px',
                  textAlign: 'center',
                  width: inputWidth - 20,
                }}
                placeholder={index === 0 ? (isEnglish ? 'Your name for food delivery' : '你在外卖平台上的名字') : (isEnglish ? 'Additional name' : '你在外卖平台上的其他名字')}
                placeFontFamily={'Inter-Regular, Inter'}
                placeholderColor={'rgba(0, 0, 0, 0.5)'}
                value={name}
                onChange={(e) => {
                  const newList = [...userNameList];
                  newList[index] = e.target.value;
                  setUserNameList(newList);

                  // 如果是最后一个输入框且有内容，自动添加一个新的
                  if (index === userNameList.length - 1 && e.target.value.trim()) {
                    setUserNameList([...newList, '']);
                  }
                }}
              />
              {
                index < userNameList.length - 1 && (
                  <div style={{ height: 1, width: '100%', backgroundColor: '#000000', opacity: 0.5 }} />
                )
              }
            </React.Fragment>
          ))
        }
      </div>

      {/* 领取快递的姓名 */}
      <div style={{ backgroundColor: 'rgba(228, 228, 228, 0.5)', borderRadius: 5, width: inputWidth, marginLeft: 'auto', marginRight: 'auto', marginTop: 15 }}>
        <RowCenter style={{ paddingTop: 10, marginBottom: 20 }}>
          <img src={AusPost} style={{ height: logoSize, width: logoSize }} />
          <img src={Amazon} style={{ height: logoSize, width: logoSize, marginLeft: 10 }} />
          <img src={DHL} style={{ height: logoSize, width: logoSize, marginLeft: 10 }} />
          <img src={Toll} style={{ height: logoSize, width: logoSize, marginLeft: 10 }} />
          <img src={FedEx} style={{ height: logoSize, width: logoSize, marginLeft: 10 }} />
        </RowCenter>
        {
          expressNameList.map((name, index) => (
            <React.Fragment key={index}>
              {
                index === 0 && !name && (
                  <InterBoldText position={'absolute'} color={'#F44336'} fontSize={20} isSpan={true} marginTop={8} marginLeft={inputWidth - (isEnglish ? 48 : 85)}>*</InterBoldText>
                )
              }
              {
                name && (
                  <Button
                    style={{ position: 'absolute', marginLeft: inputWidth - 29, marginTop: 10 }}
                    onClick={() => {
                      const newList = [...expressNameList];
                      newList[index] = '';
                      setExpressNameList(newList);
                    }}
                  >
                    <IoIosCloseCircleOutline style={{ fontSize: 23, color: '#000000' }} />
                  </Button>
                )
              }
              <Input
                style={{
                  border: 'none',
                  outline: 'none',
                  fontSize: '18px',
                  fontFamily: 'Inter-Regular, Inter',
                  fontWeight: 400,
                  color: '#000000',
                  backgroundColor: 'transparent',
                  lineHeight: '35px',
                  textAlign: 'center',
                  width: inputWidth - 20,
                }}
                placeholder={index === 0 ? (isEnglish ? 'Your name for parcel delivery' : '你在快递平台上的名字') : (isEnglish ? 'Additional name' : '你在快递平台上的其他名字')}
                placeFontFamily={'Inter-Regular, Inter'}
                placeholderColor={'rgba(0, 0, 0, 0.5)'}
                value={name}
                onChange={(e) => {
                  const newList = [...expressNameList];
                  newList[index] = e.target.value;
                  setExpressNameList(newList);

                  // 如果是最后一个输入框且有内容，自动添加一个新的
                  if (index === expressNameList.length - 1 && e.target.value.trim()) {
                    setExpressNameList([...newList, '']);
                  }
                }}
              />
              {
                index < expressNameList.length - 1 && (
                  <div style={{ height: 1, width: '100%', backgroundColor: '#000000', opacity: 0.5 }} />
                )
              }
            </React.Fragment>
          ))
        }
      </div>
    </div>
  );
};

export interface Props {
  isEnglish: boolean;
  formError: boolean;
  fullName: string;
  setFullName: (name: string) => void;
  userNameList: string[];
  setUserNameList: (list: string[]) => void;
  expressNameList: string[];
  setExpressNameList: (list: string[]) => void;
}

export default UserName;
